import type React from 'react';
import { Card, TextButton } from '@zillow/constellation-10';
import { styled } from '@/styled-system/jsx';

export const StyledLogo = styled('div', {
  base: {
    '& img': {
      width: 'auto',
      maxHeight: '70px',
      display: 'inline-block',
      verticalAlign: 'middle',
      maxWidth: '66px',
    },
  },
});

export const StyledSlugOverlay = styled('div', {
  base: {
    color: 'white',
    display: 'block',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '19px',
    margin: 0,
    maxWidth: 'calc(100% - 40px)',
    overflow: 'hidden',
    padding: '5px 15px',
    position: 'absolute',
    textTransform: 'capitalize',
    background: 'rgba(0, 0, 0, 0.54)',
    top: 0,
    right: 0,
    '&:empty': {
      display: 'none',
    },
  },
});

export const StyledHeaderOverlay = styled('div', {
  base: {
    color: 'white',
    display: 'block',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '19px',
    margin: 0,
    maxWidth: 'calc(100% - 40px)',
    overflow: 'hidden',
    padding: '5px 15px',
    position: 'absolute',
    textTransform: 'capitalize',
    background: 'rgba(0, 0, 0, 0.54)',
    top: 0,
    '&:empty': {
      display: 'none',
    },
  },
  variants: {
    position: {
      left: {
        left: 0,
      },
      right: {
        right: 0,
      },
    },
  },
  defaultVariants: {
    position: 'left',
  },
});

export const StyledEhoLogo = styled('div', {
  base: {
    display: 'block',
    background: 'url("https://adops.zillowstatic.com/Builder+In-Feed/EHO/eho_logo.png") no-repeat center center',
    backgroundSize: 'contain',
    height: '32px',
    width: '27px',
    position: 'absolute',
    bottom: '10px',
    left: '15px',
  },
});

export const StyledAdHeader = styled('div', {
  base: {
    fontSize: '15px',
    fontWeight: '700',
    lineHeight: '20px',
    color: '#2a2a33',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const StyledAdSubHeader = styled('div', {
  base: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#2a2a33',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '1px',
  },
});

export const StyledFeesDisclaimer = styled('div', {
  base: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#2a2a33',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingTop: '1px',
  },
});

export const StyledAdLink = styled('a', {
  base: {
    textDecoration: 'none',
  },
});

export const StyledAdCard = styled(Card, {
  base: {
    borderRadius: 0,
    padding: '0 !important',
    boxShadow: 'none !important',
  },
});

export const StyledAdTextContent = styled('div', {
  base: {
    padding: '3px 25px 0 8px',
    position: 'relative',
  },
});

export const StyledCtaButton = styled(TextButton, {
  base: {
    display: 'inline-block',
    '& svg': {
      position: 'relative',
      verticalAlign: 'middle',
      left: '-4px',
    },
    '& span, & svg': {
      color: '#0074e4',
      fontSize: 'small',
      fontWeight: 'body',
    },
  },
});

export const StyledBrandImage = styled('div', {
  base: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    position: 'relative',
    backgroundColor: '#e2e2e2',
    '&::before': {
      content: '""',
      display: 'block',
      paddingTop: '41.67%',
    },
  },
});
